/**
 * ¿Este navegador puede dibujar la escena en WebGL?
 *
 * En el depósito hay celulares viejos, y una pantalla en blanco no le dice
 * nada a un operario. Cuando esto da `false` se monta el dibujo isométrico en
 * SVG, que es el que venía andando: se ve peor, pero se ve.
 *
 * El resultado se calcula una sola vez y se guarda: crear contextos de WebGL
 * para preguntar es caro y el navegador los limita.
 */
let cache: boolean | null = null;

export function hayWebGL(): boolean {
  if (cache !== null) return cache;
  try {
    const lienzo = document.createElement('canvas');
    cache = !!(lienzo.getContext('webgl2') ?? lienzo.getContext('webgl'));
  } catch {
    cache = false;
  }
  return cache;
}
